<template>
  <div class="project-resume-content">
    <h2 class="project-subtitle">{{ Translator('soprasolar.project.resume.subtitle') }}</h2>
    <p>
      {{ Translator('soprasolar.project.resume.labels.type') }} :
      <strong>{{ Translator('soprasolar.project.step0.form.type.' + datas.step0.type) }}</strong>
    </p>
    <br>
    <p>
      {{ Translator('soprasolar.project.step1.form.occupation') }} :
      <strong>{{ Translator('soprasolar.project.step1.form.occupation_options.' + datas.step1.occupation ) }}</strong>
    </p>
    <!-- STEP2 -->
    <p>
      {{ Translator('soprasolar.project.step2.form.project_name') }} :
      <strong>{{ datas.step2.projectName }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step2.form.address') }} :
      <strong>{{ datas.step2.address }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step2.form.zip_code') }} :
      <strong>{{ datas.step2.zipCode }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step2.form.city') }} :
      <strong>{{ datas.step2.city }}</strong>
    </p>
    <p v-if="datas.step2.country">
      {{ Translator('soprasolar.project.step2.form.country') }} :
      <strong>{{ getCountryName(datas.step2.country) }}</strong>
    </p>
    <p v-if="datas.step2.classification">
      {{ Translator('soprasolar.project.step2.form.classification.label') }} :
      <strong>{{ Translator('soprasolar.project.step2.form.classification.' + datas.step2.classification ) }}</strong>
    </p>
    <p>
      {{ Translator('soprasolar.project.step2.form.elevation') }} :
      <strong>{{ datas.step2.elevation }}</strong>
    </p>
    <p v-if="datas.step2.category">
      {{ Translator('soprasolar.project.step2.form.category.label') }} :
      <strong>{{ Translator('soprasolar.project.step2.form.category.' + datas.step2.category ) }}</strong>
    </p>
    <p v-if="datas.step2.coefficient">
      {{ Translator('soprasolar.project.step2.form.coefficient.label') }} :
      <strong>{{ Translator('soprasolar.project.step2.form.coefficient.' + datas.step2.coefficient) }}</strong>
     <br>
    </p>

    <!-- STEP 3 & 4 -->
    <template v-if="datas.step0.type === 'terrace'">
      <p v-if="datas.step3.sealing_type">
        {{ Translator('soprasolar.project.step3_terrace.form.sealing_type.label') }} :
        <strong>{{ Translator('soprasolar.project.step3_terrace.form.sealing_type.' + datas.step3.sealing_type) }}</strong>
      </p>
      <p v-if="datas.step3.photovoltaic_process">
        {{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.label') }} :
        <strong>{{ Translator('soprasolar.project.step3_terrace.form.photovoltaic_process.' + datas.step3.photovoltaic_process ) }}</strong>
      </p>
      <p v-if="datas.step3.orientation">
        {{ Translator('soprasolar.project.step3_terrace.form.orientation.label') }} :
        <strong>{{ Translator('soprasolar.project.step3_terrace.form.orientation.' + datas.step3.orientation ) }}</strong>
      </p>
      <br>
      <p v-if="datas.step4.supporting_elements">
        {{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.label') }} :
        <strong v-if="datas.step4.supporting_elements !== 'other'">{{ Translator('soprasolar.project.step4_terrace.form.supporting_elements.' + datas.step4.supporting_elements) }}</strong>
        <strong v-else>{{ Translator('soprasolar.project.other') }} - {{ datas.step4.supporting_elements_other }}</strong>
      </p>
      <p v-if="datas.step4.project_type">
        {{ Translator('soprasolar.project.step4_terrace.form.project_type.label') }} :
        <strong>{{ Translator('soprasolar.project.step4_terrace.form.project_type.' + datas.step4.project_type ) }}</strong>
      </p>
      <p v-if="datas.step4.configuration">
        {{ Translator('soprasolar.project.step4_terrace.form.configuration.label') }} :
        <strong>{{ Translator('soprasolar.project.step4_terrace.form.configuration.' + datas.step4.configuration ) }}</strong>
      </p>
      <p v-if="datas.step4.slop_orientation">
        {{ Translator('soprasolar.project.step4_terrace.form.slop_orientation.label') }} :
        <strong>{{ Translator('soprasolar.project.step4_terrace.form.slop_orientation.' + datas.step4.slop_orientation ) }}</strong>
      </p>
      <p v-if="datas.step4.hygrometry">
        {{ Translator('soprasolar.project.step4_terrace.form.hygrometry.label') }} :
        <strong>{{ Translator('soprasolar.project.step4_terrace.form.hygrometry.' + datas.step4.hygrometry ) }}</strong>
      </p>
      <p v-if="datas.step4.roof_pitch">
        {{ Translator('soprasolar.project.step4_terrace.form.roof_pitch') }} :
        <strong>{{ datas.step4.roof_pitch }}</strong>
      </p>
      <p v-if="datas.step4.roof_length">
        {{ Translator('soprasolar.project.step4_terrace.form.roof_length') }} :
        <strong>{{ datas.step4.roof_length }}</strong>
      </p>
      <p v-if="datas.step4.roof_width">
        {{ Translator('soprasolar.project.step4_terrace.form.roof_width') }} :
        <strong>{{ datas.step4.roof_width }}</strong>
      </p>
      <p v-if="datas.step4.parapet_height">
        {{ Translator('soprasolar.project.step4_terrace.form.parapet_height') }} :
        <strong>{{ datas.step4.parapet_height }}</strong>
      </p>
      <p v-if="datas.step4.maximum_height">
        {{ Translator('soprasolar.project.step4_terrace.form.maximum_height') }} :
        <strong>{{ datas.step4.maximum_height }}</strong>
      </p>
    </template>
    <template v-else>
      <p v-if="datas.step3.modules_choices">
        {{ Translator('soprasolar.project.step3_shade.form.modules_choices.label') }} :
        <strong v-if="datas.step3.modules_choices !== 'other'">{{ Translator('soprasolar.project.step3_shade.form.modules_choices.' + datas.step3.modules_choices ) }}</strong>
        <strong v-else>{{ Translator('soprasolar.project.other') }} - {{ datas.step3.modules_choices_other }}</strong>
      </p>
      <p v-if="datas.step3.sizes">
        {{ Translator('soprasolar.project.step3_shade.form.sizes.label') }} :
        <strong>{{ Translator('soprasolar.project.step3_shade.form.sizes.' + datas.step3.sizes ) }}</strong>
      </p>
      <br>

      <div v-for="shade, index in datas.step4" :key="index">
        <strong>{{ Translator('soprasolar.project.step4_shade.collection.title', {number: index + 1}) }}</strong>
        <p v-if="shade.type">
          {{ Translator('soprasolar.project.step4_shade.form.type.label') }} :
          <strong>{{ Translator('soprasolar.project.step4_shade.form.type.' + shade.type ) }}</strong>
        </p>
        <p v-if="shade.destination">
          {{ Translator('soprasolar.project.step4_shade.form.destination.label') }} :
          <strong>{{ Translator('soprasolar.project.step4_shade.form.destination.' + shade.destination ) }}</strong>
        </p>
        <p v-if="shade.breakdown">
          {{ Translator('soprasolar.project.step4_shade.form.type_of_breakdown.label') }} :
          <strong>{{ Translator('soprasolar.project.step4_shade.form.type_of_breakdown.' + shade.breakdown ) }}</strong>
        </p>
        <p v-if="shade.roof_pitch">
          {{ Translator('soprasolar.project.step4_shade.form.roof_pitch') }} :
          <strong>{{ shade.roof_pitch }}</strong>
        </p>
        <p v-if="shade.height_bottom">
          {{ Translator('soprasolar.project.step4_shade.form.height_bottom') }} :
          <strong>{{ shade.height_bottom }}</strong>
        </p>
        <p v-if="shade.height_brace">
          {{ Translator('soprasolar.project.step4_shade.form.height_brace') }} :
          <strong>{{ shade.height_brace }}</strong>
        </p>
        <p v-if="shade.congestion_rate">
          {{ Translator('soprasolar.project.step4_shade.form.congestion_rate') }} :
          <strong>{{ shade.congestion_rate }}</strong>
        </p>
        <template v-if="datas.step3.sizes === 'approximate'">
          <p v-if="shade.approximate_length">
            {{ Translator('soprasolar.project.step4_shade.form.approximate_length') }} :
            <strong>{{ shade.approximate_length }}</strong>
          </p>
          <p v-if="shade.approximate_crawling">
            {{ Translator('soprasolar.project.step4_shade.form.approximate_crawling') }} :
            <strong>{{ shade.approximate_crawling }}</strong>
          </p>
        </template>
        <template v-if="datas.step3.sizes === 'modules'">
          <p v-if="shade.number_modules_length">
            {{ Translator('soprasolar.project.step4_shade.form.number_modules_length') }} :
            <strong>{{ shade.number_modules_length }}</strong>
          </p>
          <p v-if="shade.rampant_modules_length">
            {{ Translator('soprasolar.project.step4_shade.form.rampant_modules_length') }} :
            <strong>{{ shade.rampant_modules_length }}</strong>
          </p>
        </template>
        <p v-if="shade.rail_overhang">
          {{ Translator('soprasolar.project.step4_shade.form.rail_overhang_label') }} :
        </p>
        <template v-if="shade.rail_overhang_detail">
          <p>{{ Translator('soprasolar.project.step4_shade.form.rail_overhang_detail') }} :
          <strong>{{ shade.rail_overhang_detail }}</strong>
          </p>
        </template>
        <br>
      </div>
      <p v-if="datas.step4">
        {{ Translator('soprasolar.project.resume.shade_length') }} :
        <strong>{{ datas.step4.length }}</strong>
      </p>
    </template>
    <br>

    <!-- STEP 5 -->
    <div v-if="datas.step0.type === 'shade'">
      <p v-if="datas.step5.final_frame">
        {{ Translator('soprasolar.project.step5.form.final_frame_label') }} :
      </p>
      <template v-if="datas.step5.final_frame_file">
        <div>
          <p>{{ Translator('soprasolar.project.step5.form.final_frame_file') }} :</p>
          <p class="file-element">
            <strong>{{ datas.step5.final_frame_file.name }}</strong>
            <a :href="'/api/project-applications/' + tokenAdmin + '/document/' + datas.step5.final_frame_file.reference" download class="button-download" type="button" v-if="isAdmin" target="_blank" rel="noopener noreferrer"><i class="ic ic-download"></i></a>
          </p>
        </div>
      </template>
      <p v-if="datas.step5.jibe_optimization">
        {{ Translator('soprasolar.project.step5.form.jibe_optimization.label') }} :
        <strong>{{ Translator('soprasolar.project.step5.form.jibe_optimization.' + datas.step5.jibe_optimization ) }}</strong>
      </p>
    </div>
    <p v-if="datas.step5.insulation_sealing">
      {{ Translator('soprasolar.project.step5.form.insulation_sealing.label') }} :
      <strong>{{ Translator('soprasolar.project.step5.form.insulation_sealing.' + datas.step5.insulation_sealing ) }}</strong>
    </p>
    <p v-if="datas.step5.calepinage">
      {{ Translator('soprasolar.project.step5.form.calepinage.label') }} :
      <strong>{{ Translator('soprasolar.project.step5.form.calepinage.' + datas.step5.calepinage ) }}</strong>
    </p>
    <template v-if="datas.step5.calepinage === 'yes' && datas.step5.calepinageFile">
      <div>
        <p>{{ Translator('soprasolar.project.step5.form.calepinage_file') }} :</p>
        <p class="file-element">
          <strong>{{ datas.step5.calepinageFile.name }}</strong>
          <a :href="'/api/project-applications/' + tokenAdmin + '/document/' + datas.step5.calepinageFile.reference" download class="button-download" type="button" v-if="isAdmin" target="_blank" rel="noopener noreferrer"><i class="ic ic-download"></i></a>
        </p>
      </div>
    </template>
    <p v-if="datas.step5.modules_choices">
      {{ Translator('soprasolar.project.step5.form.modules_choices.label') }} :
      <strong v-if="datas.step5.modules_choices !== 'other'">{{ Translator('soprasolar.project.step5.form.modules_choices.' + datas.step5.modules_choices ) }}</strong>
      <strong v-else>{{ Translator('soprasolar.project.other') }} - {{ datas.step5.modules_choices_other }}</strong>
    </p>
    <p v-if="datas.step5.comment">
      {{ Translator('soprasolar.project.step5.form.comment') }} :
      <br>
      <strong v-html="datas.step5.comment"></strong>
    </p>
    <template v-if="datas.step5.files && datas.step5.files.length > 0">
      <br>
      <p v-if="datas.step0.type === 'terrace'">
        {{ Translator('soprasolar.project.step5.form.files_more_terrace') }} :
      </p>
      <p v-if="datas.step0.type === 'shade'">
        {{ Translator('soprasolar.project.step5.form.files_more_shade') }} :
      </p>
      <p v-for="file in datas.step5.files" :key="file.id" class="file-element">
        <strong>{{ file.name }}</strong>
        <a :href="'/api/project-applications/' + tokenAdmin + '/document/' + file.reference" download class="button-download" v-if="isAdmin" target="_blank" rel="noopener noreferrer">
          <i class="ic ic-download"></i>
        </a>
      </p>
      <p style="margin-top: 15px;">
        <a :href="'/api/project-applications/' + tokenAdmin + '/documents'" download class="button-download-all" v-if="isAdmin" target="_blank" rel="noopener noreferrer">
          <i class="ic ic-download"></i>
          {{ Translator('soprasolar.project.resume.download_all') }}
        </a>
      </p>
    </template>
    <button class="button-print" v-if="isAdmin && currentStep === 'finished'" @click="onPrint">
      <i class="ic ic-print"></i>
      {{ Translator('soprasolar.project.resume.print') }}
    </button>
  </div>
</template>
<style scoped lang="scss">
@import "~@/soprasolar-project/assets/styles/import";
.file-element {
  display: flex;
  align-items: center;
  gap: rem(10);
}
.project-resume-content {
  word-break: break-word;
}
.button-download {
  @include resetBtn;
  width: rem(30);
  height: rem(30);
  display: flex;
  justify-content: center;
  align-items: center;
  color: $color-main;
  .ic {
    font-size: rem(22);
  }
}
.button-download-all, .button-print {
  @include cta;
  .ic {
    margin-right: rem(10);
  }
  &:hover, &:focus {
    .ic {
      transform: none;
    }
  }
}
.button-print {
  margin-top: rem(15);
}
</style>
<script>
import AppControlService from '@/soprasolar-project/services/AppControl';
import countryListJs from 'country-list-js';

export default {
  name: 'resume',
  components: {},
  data () {
    return {
      token: AppControlService.token,
      tokenAdmin: AppControlService.tokenAdmin,
      datas: AppControlService.datas,
      currentStep: AppControlService.currentStep,
    }
  },

  computed: {
    isAdmin: () => {
      return AppControlService.isAdmin;
    }
  },

  created() {
    AppControlService.on('datas', this._onUpdateDatas);
  },

  beforeDestroy() {
    AppControlService.off('datas', this._onUpdateDatas);
  },

  mounted() {},

  methods: {
    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },

    _onUpdateDatas(datas) {
      this.datas = datas;
    },

    getCountryName(code) {
      return countryListJs.findByIso2(code)?.name;
    },

    onPrint() {
      const pageTitle = document.title;
      document.title = `N°${AppControlService.id} - ${AppControlService.datas.step1.company} - ${AppControlService.datas.step2.projectName}`;
      window.print();
      document.title = pageTitle;
    }
  }
};
</script>
